//我们组装模块并导出 store 的地方
import Vue from 'vue';
import Vuex from 'vuex';
import authModule from './modules/auth';
import permission from './modules/permission';
import common from './modules/common';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        authModule,
        permission,
        common,
    },
    getters,
    strict: process.env.NODE_ENV !== 'production',
});

if (module.hot) {
  // 使 actions 和 mutations 成为可热重载模块
  module.hot.accept([
    './modules/auth',
    './modules/permission',
    './modules/common',
    ], () => {
    // 获取更新后的模块
    // 因为 babel 6 的模块编译格式问题，这里需要加上 .default
    // 加载新模块
    store.hotUpdate({
      modules: {
        authModule: require('./modules/auth').default,
        common: require('./modules/common').default,
        permission: require('./modules/permission').default,
      }
    })
  })
}

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js